const statusModule = {
    // State
    state: {
        status: {
            monitors: {},
        },
    },

    // Mutations
    mutations: {
        saveMonitors(state, monitors) {
            state.status.monitors = monitors
        },
    },

    // Getters
    getters: {
        monitors: state => () => {
            return state.status.monitors
        },
    },
}

export default statusModule
